//CSSをバンドル
import 'Src/scss/schoolList.scss'
//共通のJavaScriptを読み込み
import 'Src/js/utils/utils'

$('.school_ListContents__titleWrap').on('click', function(){
  $(this).next().toggleClass('is-open');
  $(this).toggleClass('is-open');
});

